
// Load all svg icons at compile time.

function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../../icons', true, /\.svg$/));


// Async load compiled svg icon sprite sheet in browser
fetch(`${process.env.PUBLIC_PATH}icons/sprites.svg?v=${process.env.BUILD_TIME}`).then(resp => {
    return resp.text();
}).then(data => {
    const sprites = jQuery(data);
    sprites.attr('aria-hidden', 'true');
    sprites.css({
        position: 'absolute',
        width: 0,
        height: 0,
        overflow: 'hidden',
    });
    sprites.prependTo('body');
});
